import React from "react";
import localizationApi from "./Localizations";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookF, faTwitter, faInstagram, faYoutube} from "@fortawesome/free-brands-svg-icons";
import ubisoft_store_logo from "./images/footer/ubisoft_logo_store.png"
import ubisoft_white_logo from "./images/footer/ubisoft-white.png"

import acbMA15 from "./images/ratings/acbMA15.png"
import ceroD from "./images/ratings/ceroD.jpg"
import classind16 from "./images/ratings/classind16.png"
import esrb_mature from "./images/ratings/esrb-mature.png"
import grac19 from "./images/ratings/grac19.png"
import gsrrPG15 from "./images/ratings/gsrrPG15.png"
import pegi18 from "./images/ratings/pegi-18.png"
import rars18 from "./images/ratings/rars18.png"
import usk16 from "./images/ratings/usk16.png"

import privacyCertifiedLogo from "./images/footer/privacy-certified-globe-color-ubiosoft_110500.jpg"

import {localesWithNoSocialLinks} from "./utils";

interface Props {
    locale: string;

    onLocaleChange: (locale: string) => void;
}

const FooterCompR6e: React.FC<Props> = (props) => {
    const footerNcsaVariant = (locale: string) => {
        switch (locale) {
            case "en-US":
            case "en-CA":
                return (
                    <>

                        <a target="_blank" rel="noopener noreferrer"
                           href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src={esrb_mature} alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer"
                           href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp">
                            <img
                                src={privacyCertifiedLogo}
                                alt=""/>
                        </a>
                    </>
                );
            case "fr-CA":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer"
                           href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src={esrb_mature}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer"
                           href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp">
                            <img
                                src={privacyCertifiedLogo}
                                alt=""/>
                        </a>
                    </>
                );
            case "es-MX":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer"
                           href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src={esrb_mature}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer"
                           href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp">
                            <img
                                src={privacyCertifiedLogo}
                                alt=""/>
                        </a>
                    </>
                );
            case "pt-BR":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer"
                           href="https://www.justica.gov.br/seus-direitos/classificacao">
                            <img src={classind16} alt=""/>
                        </a>
                    </>
                );
            default:
                return null;
        }
    };

    const footerNcsa = (
        <>
            <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                    <img src={ubisoft_white_logo} alt=""/>
                </a>

                {footerNcsaVariant(props.locale)}

                <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                    <img src={ubisoft_store_logo} alt=""/>
                </a>
            </div>

            <div className="d-flex flex-column small pt-2">
                <p className="copy text-light text-center">&copy; 2015 Ubisoft Entertainment. All Rights Reserved. Tom
                    Clancy's, Rainbow Six, The Soldier Icon, Ubisoft and the Ubisoft logo are registered or unregistered
                    trademarks of Ubisoft Entertainment in the U.S. and/or other countries.</p>
                <div className="legal d-flex flex-row justify-content-center">
                    <a href="https://support.ubi.com" target="_blank" rel="noopener noreferrer"
                       className="mx-2 text-light text-center small ">
                        CUSTOMER SUPPORT
                    </a>
                    <a href="https://legal.ubi.com/termsofuse" target="_blank" rel="noopener noreferrer"
                       className="mx-2 text-light text-center small ">
                        UBISOFT TERMS OF USE
                    </a>
                    <a href="https://legal.ubi.com/privacypolicy" target="_blank" rel="noopener noreferrer"
                       className="mx-2 text-light text-center small ">
                        UBISOFT PRIVACY POLICY
                    </a>
                </div>
            </div>
        </>
    );

    const footerEmeaVariant = (locale: string) => {
        switch (locale) {
            case "en-AU":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo} alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.usk.de">
                            <img
                                src={acbMA15}
                                alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt=""/>
                        </a>
                    </>
                );
            case "de-DE":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo} alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.usk.de">
                            <img
                                src={usk16}
                                alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt=""/>
                        </a>
                    </>
                );
            case "ja-JP":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.cero.gr.jp/publics/index/17/">
                            <img src={ceroD} alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt=""/>
                        </a>
                    </>
                );
            case "ko-KR":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.grac.or.kr/">
                            <img src={grac19} alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt=""/>
                        </a>
                    </>
                );
            case "zh-TW":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.gamerating.org.tw/gsgi_way.php">
                            <img src={gsrrPG15} alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt="/"/>
                        </a>
                    </>
                );
            case "zh-CN":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt="/"/>
                        </a>
                    </>
                );
            case "ru-RU":
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo}
                                 alt=""/>
                        </a>
                        <img src={rars18} alt=""/>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt=""/>
                        </a>
                    </>
                );
            default:
                return (
                    <>
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src={ubisoft_store_logo}
                                 alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.pegi.info/">
                            <img src={pegi18} alt=""/>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src={ubisoft_white_logo} alt=""/>
                        </a>
                    </>
                );
        }
    };
    const footerEmea = (
        <>
            <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="emeaFooter">
                {footerEmeaVariant(props.locale)}
            </div>

            <div className="d-flex flex-column small">
                <p className="copy text-light text-center small">&copy; 2015 Ubisoft Entertainment. All Rights Reserved.
                    Tom Clancy's, Rainbow Six, The Soldier Icon, Ubisoft and the Ubisoft logo are registered or
                    unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries. The "PS" Family
                    logo is a registered trademark and "PS4" is a trademark of Sony Computer Entertainment Inc. Software
                    platform logo (TM and &copy;) EMA 2006.</p>
                <div className="legal d-flex flex-row justify-content-center">
                    <a href="https://legal.ubi.com/LegalInfoUbisoftEMEA" target="_blank" rel="noopener noreferrer"
                       className="mx-2 text-light text-center small ">
                        LEGAL INFORMATION
                    </a>
                    <a href="https://legal.ubi.com/termsofuse" target="_blank" rel="noopener noreferrer"
                       className="mx-2 text-light text-center small ">
                        UBISOFT TERMS OF USE
                    </a>
                    <a href="https://legal.ubi.com/privacypolicy" target="_blank" rel="noopener noreferrer"
                       className="mx-2 text-light text-center small ">
                        UBISOFT PRIVACY POLICY
                    </a>
                </div>
            </div>
        </>
    );

    var instagramUrl = localizationApi.GetInstagramUrlLocale(props.locale);

    const isNcsa = props.locale === "en-US" || props.locale === "fr-CA" || props.locale === "en-CA" || props.locale === "es-MX" || props.locale === "pt-BR";

    return (
        <footer className="bg-dark">
            <div className="container py-4">
                <div className="d-flex flex-row justify-content-between py-4">
                    <select className="p-2" onChange={(e) => props.onLocaleChange(e.target.value)} value={props.locale}>
                        {Object.keys(localizationApi.supportedLocales).map(k =>
                            <option key={k} value={k}>{localizationApi.supportedLocales[k]}</option>
                        )}
                    </select>

                    {!localesWithNoSocialLinks.includes(props.locale) &&
                        <ul className="nav">
                            <li className="nav-item">
                                <a href="https://www.facebook.com/Rainbow6" title="Facebook" className="nav-link">
                                    <FontAwesomeIcon icon={faFacebookF} color="#fff"/>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="https://twitter.com/Rainbow6Game" title="Twitter" className="nav-link">
                                    <FontAwesomeIcon icon={faTwitter} color="#fff"/>
                                </a>
                            </li>
                            {instagramUrl !== "" ? (
                                <li className="nav-item" id="instagramItem">
                                    <a href={instagramUrl} title="Instagram" className="nav-link">
                                        <FontAwesomeIcon icon={faInstagram} color="#fff"/>
                                    </a>
                                </li>
                            ) : null}
                            <li className="nav-item">
                                <a href="https://www.youtube.com/user/ubisoft" title="YouTube" className="nav-link">
                                    <FontAwesomeIcon icon={faYoutube} color="#fff"/>
                                </a>
                            </li>
                        </ul>
                    }
                </div>
                {isNcsa ? footerNcsa : footerEmea}
            </div>
        </footer>
    );
};

export default FooterCompR6e;
